import Vue from 'vue'
import Router from 'vue-router'

import Login from './views/Login.vue';
import AdminLogin from './views/AdminLogin.vue';
import Register from './views/Register.vue';
import Project from './views/Project.vue';
import ProjectBlock from './views/ProjectBlock.vue';
import Overview from './views/Overview.vue';
import Admin from './views/Admin.vue';
import AppSettings from './views/AppSettings.vue';
import ForgotPassword from './views/ForgotPassword.vue';
import SetPassword from './views/SetPassword.vue';

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Overview
    },
    {
      path: '/overview',
      component: Overview
    },
    {
      path: '/project/:projectid',
      component: ProjectBlock
    },
    {
      path: '/project/:projectid/projectblock/:projectblockid',
      component: ProjectBlock
    },
    {
      path: '/register',
      component: Register
    }, 
    {
      path: '/wachtwoord',
      component: ForgotPassword
    },
    {
      path: '/wachtwoord-bedenken',
      component: SetPassword
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/admin',
      component: Admin
    },
    {
      path: '/adminlogin',
      component: AdminLogin
    },
    {
      path: '/admin/user/:id',
      component: Admin
    },
    {
      path: '/appsettings',
      component: AppSettings
    },
    {
      path: '/admin',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: function () { 
        return import(/* webpackChunkName: "about" */ './views/Admin.vue')
      }
    },
    {
      path: '*',
      component: Overview
    }
  ]
})